import { isWeb } from "@memorang/helpers/platform";
import { ScrollView } from "react-native";
import { useDevice } from "../../useDevice";
import TooltipWrapper from "../TooltipWrapper";
import { LessonsTopicChip } from "./LessonsTopicChip";
import type { ExploreChip } from "./types";

type Props = {
	chips: ExploreChip[];
	onChipPress: (type: ExploreChip["type"]) => void;
};

export const TopicChipsRow = ({ chips, onChipPress }: Props) => {
	const { isMobile } = useDevice();

	return (
		<ScrollView
			horizontal
			showsHorizontalScrollIndicator={false}
			contentContainerStyle={{
				gap: 11,
				paddingHorizontal: isMobile ? 16 : 0,
			}}
		>
			{chips.map((chip) =>
				isWeb ? (
					<TooltipWrapper key={chip.type} title={chip.tooltip}>
						<LessonsTopicChip
							label={chip.label}
							selected={chip.selected}
							onPress={() => {
								onChipPress(chip.type);
							}}
						/>
					</TooltipWrapper>
				) : (
					<LessonsTopicChip
						key={chip.type}
						label={chip.label}
						selected={chip.selected}
						onPress={() => {
							onChipPress(chip.type);
						}}
					/>
				),
			)}
		</ScrollView>
	);
};
